module.exports = __webpack_public_path__ + "static/media/logo.a35e2522.png";